module.exports = __webpack_public_path__ + "static/waterteether4-be57c3c2eee728bf919944f2123685af.jpeg";